import {Component, OnInit, Input} from '@angular/core';
import {MainService} from "@app/main.service";

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.css']
})
export class AvatarComponent implements OnInit {


    constructor(private mainService: MainService) {

    }

    obj = [];
    avatar = '';
    fullName = '';
    shortName = '';
    previewAvatar = false;
    instance: string = '';


    @Input() avatarWidth: any;
    @Input() assigned: object;
    @Input() personalStyle: string;


    ngOnInit(): void {
        this.instance = this.mainService.apiUrl;
        if (this.assigned !== undefined) {
            this.previewAvatar = true;
            this.avatar = this.assigned['avatar'];
            this.fullName = this.assigned['first_name'] + ' ' + this.assigned['last_name'];
            this.shortName = this.assigned['shortName'];
        }
    }

}
